module.exports = __webpack_public_path__ + "fonts/Montserrat-bolditalic_ed3bc56e4cd45b0b382fd0c05d5b5939.ttf";